module.exports = __webpack_public_path__ + "img/square-blue.5f121880.svg";